import React, { useState } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";

const DodajFaktury = ({ onSave }) => {
  const [dodajMode, setDodajMode] = useState(false);
  const [iloscNowychFaktur, setIloscNowychFaktur] = useState("1");

  const [noweFaktury, setNoweFaktury] = useState([]);

  const containsInvalid = noweFaktury.some((f) => f.includes(","));

  const handleSave = () => {
    const nowe = noweFaktury.map((f) => f.trim()).filter(Boolean);
    if (nowe.length > 0) {
      onSave(nowe);
      // reset
      setDodajMode(false);
      setNoweFaktury([]);
      setIloscNowychFaktur(1);
    }
  };

  return (
    <>
      {!dodajMode && (
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => setDodajMode(true)}
          sx={{ mt: 1 }}
        >
          Dodaj faktury
        </Button>
      )}

      {dodajMode && (
        <>
          <TextField
            label="Ile nowych faktur?"
            value={iloscNowychFaktur}
            onChange={(e) => setIloscNowychFaktur(e.target.value)}
            fullWidth
            sx={{ my: 2 }}
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*", min: 1 }}
          />

          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              const parsedIlosc = parseInt(iloscNowychFaktur, 10);
              if (!parsedIlosc || parsedIlosc <= 0) return;

              const pustyArray = Array.from({ length: parsedIlosc }, () => "");
              setNoweFaktury(pustyArray);
            }}
          >
            Wygeneruj pola
          </Button>

          {noweFaktury.length > 0 && (
            <>
              <Typography variant="body2" sx={{ mt: 2 }}>
                Wprowadź numery nowych faktur:
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                {noweFaktury.map((val, i) => {
                  const hasComma = val.includes(",");

                  return (
                    <Grid item xs={6} sm={4} key={i}>
                      <TextField
                        label={`Faktura ${i + 1}`}
                        fullWidth
                        value={val}
                        error={hasComma}
                        helperText={
                          hasComma
                            ? "Numer faktury nie może zawierać przecinka (,)"
                            : ""
                        }
                        onChange={(e) => {
                          const updated = [...noweFaktury];
                          updated[i] = e.target.value;
                          setNoweFaktury(updated);
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>

              <Button
                variant="contained"
                color="success"
                sx={{ mt: 2 }}
                onClick={handleSave}
                disabled={containsInvalid}
              >
                Zapisz faktury
              </Button>
            </>
          )}
        </>
      )}
    </>
  );
};

export default DodajFaktury;
